import { motion } from 'framer-motion';

export default function TrustedCertified() {
  const services = [
    { icon: '/ico-certified.png', height: 'h-[9rem]' }, // Normal
    { icon: '/ukascertified.png', height: 'h-[9rem]' }, // Normal
    { icon: '/isoqarregistered.png', height: 'h-[10rem]' }, // Slightly taller
    { icon: '/sia.png', wide: true, height: 'h-auto max-h-[12rem] w-[20rem]' }, // Wide logo
    { icon: '/ssip.png', height: 'h-[9rem]' }, // Small
    { icon: '/chas.png', wide: true, height: 'h-auto max-h-[12rem] w-[20rem]' }, // Wide
  ];

  return (
    <div className="mt-0 flex w-full justify-center py-[4rem] font-inter md:mt-[6rem]">
      <div className="flex w-full max-w-[114rem] flex-col items-stretch justify-center px-[2rem]">
        {/* ===== HEADING ===== */}
        <div className="flex flex-col items-center text-center">
          <h1 className="text-[2.6rem] font-[600] leading-[3.38rem] text-white">
            We Are <span className="text-[#0ec9ac]">Trusted</span>, Registered
          </h1>
        </div>

        {/* ===========================
            DESKTOP GRID
        ============================ */}
        <motion.div
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="hidden w-full flex-wrap items-center justify-between pb-[2rem] pt-[4rem] sm:flex"
        >
          {services.map((item, index) => (
            <div
              key={index}
              className="flex h-[16rem] w-[18rem] flex-col items-center justify-center text-center"
            >
              <img
                src={item.icon}
                alt="badge"
                className={`w-auto ${item.wide ? item.height : item.height}`}
              />
            </div>
          ))}
        </motion.div>

        {/* ===========================
            MOBILE GRID
        ============================ */}
        <motion.div
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="flex w-full flex-wrap items-center justify-center gap-y-[2rem] py-[2rem] sm:hidden"
        >
          {services.map((item, index) => (
            <div
              key={index}
              className="flex h-[14rem] w-[16rem] flex-col items-center justify-center text-center"
            >
              <img
                src={item.icon}
                alt="badge"
                className={`w-auto ${item.wide ? item.height : item.height}`}
              />
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}
